import angular from 'angular';
import '@uirouter/angularjs';
import 'oclazyload';
import 'angular-translate';
import 'angular-loading-bar';

import middleware from '../middleware/middleware.module';
import auth from '../auth/auth.module';
import pmsApi from '../pms-api/pms-api.module';
import 'angular-acl';
import vcRecaptcha from 'angular-recaptcha';
import ngCookies from 'angular-cookies';
import uiSelect from 'ui-select';
import toastr from 'angular-toastr';

import components from '../app-modules/register';
import directives from '../ui/directives/register';

import { AuthProvider } from '../app/services/authProvider.service';
import { coreRouting } from './core.routing';
import config from './core.config';
import middlewareConfig from './core.middleware';
import run from './core.run';
import dynamicRouting from './core.dynamic-routing';

const bootstrap = angular
    .module('app-core', [
        'ui.router',
        'oc.lazyLoad',
        'pascalprecht.translate',
        'angular-loading-bar',
        middleware,
        auth,
        pmsApi,
        'mm.acl',
        vcRecaptcha,
        ngCookies,
        'ui.select',
        toastr,
    ])
    .service('AuthProvider', AuthProvider)
    .config(config)
    .config(middlewareConfig)
    .config(coreRouting)
    .run(run)
    .run(dynamicRouting);

components(bootstrap);
directives(bootstrap);

export default bootstrap;



// WEBPACK FOOTER //
// ./src/app-core/core.module.js